module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-13-27.144Z.c2af7932.png";